// Namespaces
wfx = wfx || {};
wfx.ui = wfx.ui || {};

/**
 * Check if browser or PWA access
 */
wfx.ui.isInStandaloneMode = function() {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    return (window.matchMedia('(display-mode: standalone)').matches)
        || (window.navigator.standalone)
        || document.referrer.includes('android-app://')
        || (ios && !safari);
}
